<template>
  <div class="mainpage">
    <div class="maincontain">
      <div class="head">
        <div class="mask"></div>
      </div>
      <div class="contain">
        <div class="leftcontain">
          <div class="left-bts">
            <div class="btitemcontain" :class="{ 'active': activebtid == index }" @click="clickbt(index, item, $event)"
              v-for="(item, index) in btlist" :key="index">
              <div class="btleft">
                <el-image class="elimage" :src="item.icon1" v-if="activebtid != index" />
                <el-image class="elimage" :src="item.icon2" v-else />
                <div class="btname">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="rightcontain">
          <component :is="componentId"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyActivity from "./myActivity" // 我的技能
import myResource from "./myResource" // 我的技能
import Personal from "./personal" // 个人中心
import Security from "./security" // 账户安全
import { getuserinfo } from "@/api/user"
import bus from "@/utils/bus"
const userType = {
  0: "其他",
  1: "学生",
  2: "老师",
  3: "校外人员",
  4: "管理员",
}
export default {
  name: "mainpage",
  components: {
    MyActivity,
    myResource,
    Personal,
    Security
  },
  filters: {
    userFilter(type) {
      return userType[type]
    }
  },
  data() {
    return {
      identifier: 1,
      userInfo: {},
      activebtid: 0,
      componentId: "MyActivity",
      total: 0,
      searchvalue: "",
      testimage: require("@/assets/default/test.png"),
      testimageicon: require("@/assets/icon/title.png"),
      icon1: require("@/assets/coursedetails/考试 (1).png"),
      notice1: require("@/assets/home/notice.png"),
      notice2: require("@/assets/home/notice_1.png"),

      btlist: [
        {
          name: "我报名的活动",
          component: "MyActivity",
          icon1: require("@/assets/home/personal.png"),
          icon2: require("@/assets/home/personal_1.png"),
        },
        {
          name: "我的云库资源",
          component: "myResource",
          icon1: require("@/assets/home/natural_resources.png"),
          icon2: require("@/assets/home/natural_resources_1.png"),
        },
        {
          name: "个人信息",
          component: "Personal",
          icon1: require("@/assets/home/personal.png"),
          icon2: require("@/assets/home/personal_1.png"),
        },
        {
          name: "账号安全",
          component: "Security",
          icon1: require("@/assets/home/account.png"),
          icon2: require("@/assets/home/account_1.png"),
        },
      ],
    }
  },
  created() {
    // 接受兄弟组件传递的参数
    bus.$on("change-page", (val) => {
      this.activebtid = val.active
      this.componentId = val.componentId
    })
    const activePage = JSON.parse(sessionStorage.getItem("my-page"))
    this.activebtid = this.$route.query.index ? this.$route.query.index : activePage.active
    this.componentId = this.$route.query.componentId ? this.$route.query.componentId : activePage.componentId

    this.getUserInfo()

  },
  mounted() { },
  methods: {
    getUserInfo() {
      const params = {}
      getuserinfo(params)
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.userInfo = res.data
          }
        })
        .catch(() => { })
    },
    // 切换页面
    clickbt(index, item, event) {
      // this.activebtid = index
      this.componentId = item.component
      let mypage = {
        active: index,
        componentId: item.component,
      }
      sessionStorage.setItem("my-page", JSON.stringify(mypage))
      this.updateQueryParam()
      if (index != this.activebtid) {
        this.activebtid = index
        // 计算当前按钮的位置，看是否需要移动
        const spanLeft = event?.clientX || 0 // 当前点击的元素左边距离
        // console.log("spanLeft", spanLeft);
        const divBox = document.querySelector(".left-bts .btitemcontain").clientWidth / 2 // 点击的元素一半宽度
        // console.log("divBox", divBox);
        const totalWidths = document.body.clientWidth // 屏幕总宽度
        // console.log("totalWidths", totalWidths);
        const widths = totalWidths / 2 // 一半的屏幕宽度
        // console.log("widths", widths);
        const spanRight = totalWidths - spanLeft // 元素的右边距离
        // console.log("spanRight", spanRight);
        const scrollBox = document.querySelector(".left-bts") // 获取最外层的元素
        const scrollL = scrollBox.scrollLeft // 滚动条滚动的距离
        // 当元素左边距离 或者 右边距离小于100时进行滑动
        if (spanRight < 400 || spanLeft < 400) {
          scrollBox.scrollLeft = scrollL + (spanLeft - widths) + divBox
          // console.log("scrollBox.scrollLeft", scrollBox.scrollLeft);
        }
      }
    },
    todetail() {
      this.$router.push({
        path: "/openroom/roomdetails",
      })
    },
    // 修改查询参数的方法
    updateQueryParam(obj) {
      // 获取当前的路由信息对象
      const route = this.$route
      // 获取查询参数对象
      let query = { ...route.query }
      if (obj) {
        // 循环对象获取键与值 设置或更新查询参数
        Object.keys(obj).forEach((key) => {
          query[key] = obj[key]
        })
      } else {
        query = {}
      }
      // 使用 `push` 方法更新地址栏URL
      // this.$router.push({ path: route.path, query });
      // 或者使用 `replace` 方法，它不会在 history 中留下记录
      this.$router.replace({ path: route.path, query }).catch(() => { })
    }
  },
};
</script>
<style scoped lang="scss">
.mainpage {
  .maincontain {
    border-radius: 5px;

    .head {
      width: 100%;
      height: 300px;
      position: relative;
      background: url(~@/assets/home/mini_bg.jpg) no-repeat;
      background-size: 100% 100%;

      .mask {
        background: rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
      }
    }

    .contain {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin: 30px auto 20px;

      .leftcontain {
        width: 290px;
        min-height: calc(100vh - 500px);
        background: #ffffff;

        .btitemcontain {
          width: 100%;
          height: 60px;
          color: #333333;
          background-color: #ffffff;
          border-left: 3px solid transparent;
          box-shadow: 0px 0px 1px 0px #ffffff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          user-select: none;
          cursor: pointer;

          .btleft {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-left: 20%;

            .elimage {
              margin-left: 10px;
              margin-right: 10px;
              width: 20px;
              height: 20px;
            }

            .btname {
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 400;
            }
          }
        }

        .btitemcontain.active {
          color: #005cbb !important;
          background-color: #e5eef8;
          border-color: #005cbb;
        }
      }

      .rightcontain {
        margin-left: 20px;
        height: 100%;
        min-height: calc(100vh - 500px);
        min-width: 80%;
        flex: 1;
        background-color: #fff;
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .mainpage {
    .maincontain {
      .head {
        height: 150px;
      }

      .contain {
        flex-direction: column;
        margin: 15px auto 10px;

        .leftcontain {
          width: 100%;
          min-height: auto;

          .left-bts {
            display: flex;
            overflow-x: auto;

            .btitemcontain {
              flex-shrink: 0;
              width: auto;
              height: 44px;
              padding: 0 12px;
              border-left: none;
              border-bottom: 3px solid transparent;

              .btleft {
                margin-left: 0;

                .btname {
                  font-size: 13px;
                }

                .elimage {
                  width: 16px;
                  height: 16px;
                }
              }
            }

            .btitemcontain.active {
              border-bottom-color: #005cbb;
            }
          }
        }

        .rightcontain {
          margin-left: 0;
          margin-top: 10px;
          min-width: 100%;
          min-height: auto;
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .mainpage {
    .maincontain {
      .contain {
        .leftcontain {
          width: 200px;
        }

        .rightcontain {
          min-width: auto;
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}
</style>